import type { StaffRole } from "@apartos/contracts";

export const permissionLabels: Record<string, string> = {
  "*": "Полный доступ",
  "apartments.manage": "Апартаменты",
  "bookings.manage": "Бронирования",
  "stays.manage": "Заезды и выезды",
  "guests.manage": "Гости",
  "housekeeping.manage": "Уборки",
  "housekeeping.work": "Назначенные уборки",
  "room_service.manage": "Рум-сервис",
  "room_service.work": "Назначенные заказы",
  "cash.expenses.manage": "Расходы и касса смены",
  "payments.manage": "Платежи",
  "payments.collect": "Приём оплат без финансовой аналитики",
  "reports.view": "Отчёты",
  "reports.manage": "Рассылки отчётов",
  "team.manage": "Управление сотрудниками и доступами",
  "team.view": "Просмотр профилей сотрудников",
  "team.operations.manage": "Операционный доступ сервисной команды",
  "team.documents.manage": "Личные дела сотрудников",
  "settings.manage": "Настройки и интеграции",
  "smart_locks.view": "Просмотр умных замков",
  "smart_locks.manage": "Управление умными замками",
  "smart_locks.credentials.view": "Просмотр PIN-кодов",
  "smart_locks.credentials.create": "Создание PIN-кодов",
  "smart_locks.credentials.revoke": "Отзыв PIN-кодов",
  "smart_locks.remote_unlock": "Удалённое открытие замков",
  "smart_locks.logs.view": "Журнал доступа",
  "smart_locks.integrations.manage": "Настройка TTLock",
};

export const staffRoles: Record<StaffRole, {
  label: string;
  short: string;
  description: string;
  permissions: string[];
  telegramRecommended: boolean;
}> = {
  owner: {
    label: "Директор",
    short: "Полный контроль",
    description: "Финансы, команда, настройки и все операционные разделы.",
    permissions: ["*"],
    telegramRecommended: false,
  },
  manager: {
    label: "Менеджер",
    short: "Операционный контроль",
    description: "Управляет номерным фондом, принимает оплаты и координирует сервисные команды без доступа к финансовой аналитике и кадровым документам.",
    permissions: ["apartments.manage", "bookings.manage", "stays.manage", "guests.manage", "housekeeping.manage", "room_service.manage", "payments.collect", "cash.expenses.manage", "team.view", "team.operations.manage", "smart_locks.view", "smart_locks.manage", "smart_locks.credentials.view", "smart_locks.credentials.create", "smart_locks.credentials.revoke", "smart_locks.logs.view"],
    telegramRecommended: false,
  },
  administrator: {
    label: "Главный администратор",
    short: "Стойка и доступы",
    description: "Брони, гости, заезды, приём оплат, учётные записи сотрудников и защищённые кадровые документы — без аналитики доходов.",
    permissions: ["bookings.manage", "stays.manage", "guests.manage", "housekeeping.manage", "room_service.manage", "payments.collect", "cash.expenses.manage", "team.view", "team.manage", "team.documents.manage", "smart_locks.view", "smart_locks.manage", "smart_locks.credentials.view", "smart_locks.credentials.create", "smart_locks.credentials.revoke", "smart_locks.logs.view"],
    telegramRecommended: false,
  },
  concierge: {
    label: "Консьерж",
    short: "Гостевой сервис",
    description: "Работает с гостями, заездами и запросами, ставит задачи уборке и рум-сервису; не видит финансы и сотрудников.",
    permissions: ["bookings.manage", "stays.manage", "guests.manage", "housekeeping.manage", "room_service.manage", "payments.collect", "cash.expenses.manage", "smart_locks.view", "smart_locks.credentials.view", "smart_locks.credentials.create", "smart_locks.credentials.revoke"],
    telegramRecommended: true,
  },
  accountant: {
    label: "Бухгалтер",
    short: "Финансовый доступ",
    description: "Платежи, возвраты и отчётность без доступа к проживанию.",
    permissions: ["payments.manage", "reports.view", "reports.manage"],
    telegramRecommended: false,
  },
  housekeeper: {
    label: "Горничная",
    short: "Только уборки",
    description: "Получает назначенные уборки, чек-лист и сообщает о дефектах.",
    permissions: ["housekeeping.work"],
    telegramRecommended: true,
  },
  room_service: {
    label: "Рум-сервис",
    short: "Заявки гостей",
    description: "Доставка, бельё, мини-бар и дополнительные услуги в номер.",
    permissions: ["room_service.work"],
    telegramRecommended: true,
  },
  viewer: {
    label: "Наблюдатель",
    short: "Без изменений",
    description: "Только просмотр сводных отчётов.",
    permissions: ["reports.view"],
    telegramRecommended: false,
  },
};

export function rolePermissions(role: StaffRole): string[] {
  return [...staffRoles[role].permissions];
}
